import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import Navbar from '../Navbar';
import logo from '../../images/Limitless-BNG_WordmarkLogo.png';
import './index.scss';

const HOURS = [
  ['Monday',    '11:30AM - 2AM'],
  ['Tuesday',   '11:30AM - 2AM'],
  ['Wednesday', '11:30AM - 2AM'],
  ['Thursday',  '11:30AM - 2AM'],
  ['Friday',    '11:30AM - 2AM'],
  ['Saturday',  '11:30AM - 2AM'],
  ['Sunday',    '11:30AM - 12AM'],
];

const MAINS = [
  {
    name: 'BUILD YOUR OWN FRIES',
    price: '$12.99',
    desc: 'Fresh veggies topped with sour cream and spicy mayo',
    note: 'Protein: Pork Belly, Crispy Chicken, Beef, Jerk Chicken, or Jerk Pork',
  },
  {
    name: 'BUILD YOUR GRILLED PLATTER',
    price: '$13.99',
    desc: 'Choice of 2 proteins: Adobo Lemongrass Chicken, Pork Belly, Pork Chop, or 3 BBQ Skewers (chicken or pork). ADDITIONAL SKEWER $1',
  },
  {
    name: 'STIR-FRIED GARLIC BEEF',
    price: '$13.99',
    desc: 'Stir-fried garlic beef cubes with rice',
    note: 'Upgrade to Garlic Rice for $1',
  },
  {
    name: 'CRISPY PORK CUTLET',
    price: '$13.99',
    desc: 'Panko-crusted pork cutlet topped with okonomiyaki sauce, Japanese mayo, nori, sesame seed, and green onions',
  },
];

const BURGERS = [
  {
    name: 'CRISPY CHICKEN BURGER',
    price: '$12.99',
    desc: 'Deep-fried chicken thigh fillet on a brioche bun',
  },
  {
    name: 'LIMITLESS CLASSIC BURGER',
    price: '$12.99',
    desc: 'Grilled beef patty with lettuce, tomatoes, cheese, pickles, and our secret burger sauce',
  },
  {
    name: 'PULLED PORK SANDWICH',
    price: '$12.99',
    desc: 'Smoked pork shoulder with house spice blend and smothered in Kansas BBQ Sauce',
  },
];

class LunchSpecial extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="lunch-special">
        <Navbar />

        <div className="lunch-body">
          <Link to="/landing2" className="back-btn">&#8592;</Link>

          {/* Chalkboard Header */}
          <div className="chalkboard">
            <div className="chalk-logo-placeholder" />
            <p className="chalk-available">AVAILABLE FROM 12:00PM - 4:00 PM</p>
            <p className="chalk-note">*ALL DISHES COME WITH A SOFT DRINK OF YOUR CHOICE</p>

            <div className="chalk-content">
              {/* Vertical LUNCH SPECIAL watermark */}
              <div className="chalk-watermark">
                <span>LUNCH</span>
                <span>SPECIAL</span>
              </div>

              <div className="chalk-menu">
                {/* Mains */}
                <h2 className="chalk-section">MAINS</h2>
                {MAINS.map(({ name, price, desc, note }) => (
                  <div className="chalk-item" key={name}>
                    <div className="chalk-item-row">
                      <span className="chalk-item-name">{name}</span>
                      <span className="chalk-item-price">{price}</span>
                    </div>
                    {desc && <p className="chalk-item-desc">{desc}</p>}
                    {note && <p className="chalk-item-note">{note}</p>}
                  </div>
                ))}

                {/* Burgers / Sandwiches */}
                <h2 className="chalk-section">BURGERS/SANDWICHES</h2>
                {BURGERS.map(({ name, price, desc }) => (
                  <div className="chalk-item" key={name}>
                    <div className="chalk-item-row">
                      <span className="chalk-item-name">{name}</span>
                      <span className="chalk-item-price">{price}</span>
                    </div>
                    {desc && <p className="chalk-item-desc">{desc}</p>}
                  </div>
                ))}
              </div>
            </div>

            <p className="chalk-address">1450 Centre St Unit 3,</p>
            <p className="chalk-address">Thornhill, ON L4J 3N1</p>
            <p className="chalk-instagram">&#9312; @limitlessbng</p>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer" id="contact">
          <div className="footer-top">
            <div className="footer-col">
              <h3>Contact Us</h3>
              <p>1450 Centre St., Unit 3</p>
              <p>L4J 3N1, Thornhill, ON</p>
              <br />
              <p>T: (905) 597-5252</p>
              <p>E: limitlessbarandgrill@gmail.com</p>
            </div>
            <div className="footer-col">
              <h3>Store Hours</h3>
              {HOURS.map(([day, hrs]) => (
                <div className="hours-row" key={day}>
                  <span>{day}</span>
                  <span>{hrs}</span>
                </div>
              ))}
            </div>
            <div className="footer-col footer-logo-col">
              <img src={logo} alt="Limitless Bar & Grill" className="footer-logo" />
            </div>
          </div>
          <div className="footer-social">
            <a href="https://www.facebook.com/limitlessbng" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
            </a>
            <a href="https://www.instagram.com/limitlessbng" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
          </div>
        </footer>
      </div>
    );
  }
}

export default LunchSpecial;
